<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-pt-4 wf-pb-2' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses(classes('containerClasses'))">
      <img
        :class="elementClasses(classes('classes'), [...classes('customClasses'), 'wf-inline-block'])"
        :style="elementStyles(styles('styles'))"
        :src="src"
        :alt="alt"
      />
    </div>
  </div>
</template>

<script>
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    computed: {
      assets() {
        return this.$store.getters[`${this.module}/assets`](this.element)
      },
      src() {
        if (this.content.srcType == 'external') {
          return this.srcLink
        }
        if (this.content.srcType == 'media') {
          return this.srcMedia
        }
      },
      srcMedia() {
        let sources = this.assets[this.device].filter(asset => asset.element == 'sourceImage')
        if (! sources.length) {
          return '/img/placeholder.png'
        }
        if (this.content.srcSize == 'custom') {
          return sources.find(source => source.size == 'original').image
        }
        return sources.length ? sources.find(source => source.size == this.content.srcSize).image : '/img/placeholder.png'
      },
      srcLink() {
        let srcLink = this.$store.getters[`${this.module}/content`](this.element).srcLink
        return srcLink ? srcLink : '/img/placeholder.png'
      },
      alt() {
        return this.$store.getters[`${this.module}/content`](this.element).alt
      }
    },
  })
</script>